import { inject } from '@angular/core';
import { angularjs } from '@app/service/migration-helpers/angularjs.injection';
import { type } from '@ngrx/signals';
import { eventGroup, Events } from '@ngrx/signals/events';
import { filter, from, map, mergeMap } from 'rxjs';

export const enhancementEvents = eventGroup({
  source: 'Enhancement',
  events: {
    loadTemplateAttempt: type<string>()
  }
});

export const ENHANCEMENT_EFFECTS = (
  store: any,
  events = inject(Events),
  templateStore: any = inject(angularjs.SelectionTemplateDataStore)
) => ({
  loadTemplateByQuery$: events.on(enhancementEvents.loadTemplateAttempt).pipe(
    filter(({ payload }) => !store.templateMap()[payload]),
    mergeMap(({ payload }) =>
      from(templateStore.getSelectionTemplateDataMap(payload)).pipe(map((res) => store.loadTemplateSuccess(res)))
    )
  )
});
